import React from 'react'
import { Container } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import IntegrationSelector from './IntegrationSelector'
import ContainerTypes from './ContainerTypes'

export default function ContainerTypesPage() {
  const navigate = useNavigate()
  const { integrationId } = useParams<{ integrationId: string }>()

  const handleIntegrationSelected = (selectedIntegrationId: string) => {
    navigate(`/integrations/${selectedIntegrationId}/container-types`)
  }

  if (!integrationId) {
    return (
      <IntegrationSelector
        title="Container Types"
        description="Container types are configured per integration."
        icon={<Container className="h-6 w-6 text-purple-600" />}
        onIntegrationSelected={handleIntegrationSelected}
      />
    )
  }

  return (
    <div className="p-6">
      <ContainerTypes />
    </div>
  )
}